<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
  
<v-toolbar-title>
  <router-link to="/" tag="span" style="cursor: pointer">
  {{ cmp.name || 'BIJOY TEXTILES' }}
  </router-link>
  </v-toolbar-title>
      <v-spacer></v-spacer>

      
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'App',
  components: {
  
  },
  data: () => ({
    //
  }),
  computed: {
    cmp() {
      return this.$store.state.company.company
    }

  },
  mounted() {
    this.get_company()
    //this.$store.dispatch('company/GET_COMPANY')
  },
  methods: {
    ...mapActions({
      get_company: 'company/GET_COMPANY'
    })
    
  }
};
</script>